export const LEGAL_TEAM_APPROVAL_REQUIRED = 'legalTeamApprovalRequired'
export const LEGAL_TEAM_APPROVAL_REQUIRED_NOTES =
  'legalTeamApprovalRequiredNotes'
export const FACT_FIND_CHECKED = 'factFindChecked'
export const FACT_FIND_ERRORS_DETECTED = 'factFindErrorsDetected'
export const FACT_FIND_ERRORS_FIXED = 'factFindErrorsFixed'
export const IS_READY_FOR_REFERRAL = 'isReadyForReferral'
export const REFERRAL_TO_LEGAL_TEAM_NOTES = 'referralToLegalTeamNotes'
